<template>
  <b-modal
    :title="file.categoria
      ? `Responder Expediente ${file.categoria}-${file.numeroExt}`
      : `Responder Expediente ${file.numero}`"
    v-model="showModal"
    hide-footer
    centered
  >
    <form @keydown.enter.prevent autocomplete="off" data-vv-scope="answerForm">
      <div>
        Si decides responder este expediente vas a ser re-dirigido a un formulario
        y éste expediente quedará referenciado.
      </div>
      <div class="mt-3">
        <div class="bg-alert p-3">
          Por favor selecciona con que tipo de expediente quieres responder, recuerda que
          <b>trámite interno es procesado por oficinas internas</b>
        </div>
        <div class="mt-3">
          <vs-select
            class="w-100"
            autocomplete
            label="Tipo de Expediente respuesta"
            name="formatDocument"
            v-model="fileType"
          >
            <vs-select-item
              :value="'numInt'"
              text="Numeración interna"
            />
            <vs-select-item
              :value="'numOf'"
              text="Numeración Of. Partes"
            />
          </vs-select>
        </div>
        <div class="mt-3">
          <list-user-groups
            class="w-100"
            autocomplete
            only-groups
            label="Grupo al que irá asociado el expediente"
            name="creatorGroup"
            v-model="creatorGroup"
            :danger="errors.has('answerForm.creatorGroup')"
            :danger-text="errors.first('answerForm.creatorGroup')"
            v-validate="{ required: userGroupsState.list.length > 0 }"
            ref="creatorGroup"
          />
        </div>
      </div>
      <div class="m-top-20" style="display: flex;justify-content: flex-end;">
        <vs-button color="dark" v-on:click="cancelAsign()" type="border">Cancelar</vs-button>
        <vs-button
          v-on:click="attemptAnswerFile()"
          color="primary"
          style="margin-left: 12px;"
          type="border"
        >
          Si, Responder
        </vs-button>
      </div>
    </form>
  </b-modal>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

import ListUserGroups from '@/febos/chile/lists/components/ListUserGroups';

export default {
  name: 'PopUpAnswerFile',
  components: {
    ListUserGroups
  },
  mixins: [],
  data() {
    return {
      fileType: 'numInt',
      creatorGroup: ''
    };
  },
  props: {
    file: {
      type: [Object],
      required: true,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters('Modals', ['modalName']),
    ...mapGetters('List', ['userGroupsState']),
    ...mapGetters('Usuario', ['currentUser']),
    ...mapGetters('Empresas', ['company']),
    ...mapGetters('Dnts', ['detailsFile']),
    showModal: {
      get() {
        return this.modalName === 'answerFile';
      },
      set() {
        this.closeModal();
      }
    },
    isConventionOrSISS() {
      return this.company.iut.match(/60100003-2|61221000-4/);
    }
  },
  watch: {
    showModal(val) {
      if (val) this.getFileData();
      const groups = this.userGroupsState.list
        .filter((group) => group.isOffice === 'N' || group.isOffice === 'false') || [];
      if (groups && groups.length === 1) {
        this.creatorGroup = groups[0].id;
      }
    }
  },
  methods: {
    ...mapActions('Dnts', [
      'answerCreateFile',
      'getFileDnt'
    ]),
    ...mapActions('Modals', [
      'closeModal'
    ]),
    getFileData() {
      this.getFileDnt({
        febosId: this.file.febosId,
        dnt: 'si',
        retornarDnt: 'si',
        destinatarios: 'si',
        referencias: 'si',
        adjuntos: 'si',
        metadata: 'si'
      });
    },
    async attemptAnswerFile() {
      const creatorGroupName = this.creatorGroup
        ? this.$refs.creatorGroup.getOption().label
        : '';
      const isValid = await this.$validator.validateAll('answerForm');
      if (!isValid) return;

      const subject = {};
      switch (this.file.compradorArea) {
        case 'Ciudadano/a':
          subject.tipoDestinoCodigo = '6'; // personas naturales
          subject.tipoDestino = 'personas'; // personas naturales
          subject.tipoDestinoNombre = 'Personas'; // personas naturales
          subject.destinoListaNombre = this.file.despachoContactoNombre;
          subject.destinoListaCodigoId = this.file.despachoContactoNombre;
          break;
        case 'Persona jurídica':
          subject.tipoDestinoCodigo = '8'; // personas juridica
          subject.tipoDestino = 'personasJuridicas'; // personas juridica
          subject.tipoDestinoNombre = 'Personas Juridicas'; // personas juridica
          subject.destinoListaNombre = this.file.despachoContactoNombre;
          subject.destinoListaCodigoId = this.file.despachoContactoNombre;
          break;
        case 'Organismo del estado':
          subject.tipoDestinoCodigo = '9'; // Organismo del estado
          subject.tipoDestino = 'organismoEstado'; // Organismo del estado
          subject.tipoDestinoNombre = 'Organismo del estado'; // Organismo del estado
          subject.destinoListaNombre = this.file.transportePuertoNombre;
          subject.destinoListaCodigoId = this.file.transportePuertoNombre;
          break;
        case 'Convencional':
          subject.tipoDestinoCodigo = '0'; // usuarios
          subject.tipoDestino = 'usuarios'; // usuarios
          subject.tipoDestinoNombre = 'Funcionarios'; // usuarios
          subject.destinoListaNombre = this.file.emisorContactoNombre; // nombre del convencional
          subject.destinoListaCodigoId = this.file.emisorContactoDocumentoId;
          // id del usuario convencional
          break;
        case 'Comisión':
          subject.tipoDestinoCodigo = '7'; // usuarios
          subject.tipoDestino = 'comisiones'; // usuarios
          subject.tipoDestinoNombre = 'Comisiones'; // usuarios
          subject.destinoListaNombre = this.file.emisorContactoNombre; // nombre del convencional
          subject.destinoListaCodigoId = this.file.emisorContactoDocumentoId;
          // id del usuario convencional
          break;
        default:
          console.log('');
      }
      let answerFile = {
        dnt: {
          tipo: 'EXP',
          emisorRut: this.company.iut,
          categoria: this.file.categoria || '',
          receptorRut: this.company.iut,
          emisorRazonSocial: this.company.razonSocial,
          receptorRazonSocial: this.company.razonSocial,
          claseMercadoPublico: this.fileType,
          estado: 3,
          solicitanteGrupoId: this.creatorGroup,
          solicitanteGrupoNombre: creatorGroupName,
          compradorCodigo: this.creatorGroup,
          compradorArea: creatorGroupName,
          emisorContactoNombre: this.currentUser.nombre,
          emisorContactoCodigo: this.currentUser.id,
          estadoCodigoEstadoComprador: '0'
        },
        referencias: [
          {
            linea: 1,
            tipoDocumento: this.file.tipo,
            folio: this.file.numero,
            otraReferenciaId: this.file.febosId
          }
        ]
      };

      const cantBeSubjects = ['docDigital', 'centralAdministration'];

      if (this.isConventionOrSISS
        && !cantBeSubjects.includes(this.file.transporteTransportistaCargo)
      ) {
        answerFile = {
          ...answerFile,
          destinatarios: [
            {
              tipoDestino: 1,
              estado: 1,
              destinoCodigoId: subject.tipoDestinoCodigo,
              destinoCodigo: subject.tipoDestino,
              destinoNombre: subject.tipoDestinoNombre,
              destinoListaNombre: subject.destinoListaNombre,
              destinoListaCodigoId: subject.destinoListaCodigoId,
              destinoListaCodigo: subject.destinoListaCodigoId,
              destinoCorreo: this.file.despachoContactoEmail
            }
          ]
        };
      }
      await this.answerCreateFile(answerFile);
    },
    cancelAsign() {
      this.closeModal();
    }
  },
  created() {
    if (this.isConventionOrSISS) {
      this.fileType = 'numOf';
    } else {
      this.fileType = 'numInt';
    }
  }
};
</script>
<style scoped>

.bg-alert {
  background: #671e85;
  border-radius: 5px;
  color: white;
}

</style>
